import {Component, OnInit} from '@angular/core';
import {AngularGridInstance, Column, GridOption} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotifierService} from 'angular-notifier';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset = [];
  angularGrid: AngularGridInstance;
  totalData: number;
  selectedTitles: any[];
  gridObj: any;
  gridWidth: number;
  show: boolean;
  selected: number;
  totalItems: any;
  private notifier: NotifierService;
  dateStart: any;
  dateEnd: any;
  respObject: any;
  private clientId: number;
  type: string;
  tickets = [];
  ticketSelected: number;
  hide_report_loader = true;

  categories = [];
  categorySelected: number;
  status = [];
  statusSelected: number;

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    const classes = document.getElementsByClassName('search-filter');
    for (let i = 0; i < classes.length; i++) {
      classes[i].setAttribute('placeholder', '');
    }
  }

  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
  }

  ngOnInit() {
    this.columnDefinitions = [];
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
            this.tickets = this.respObject.details;
            this.ticketSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', JSON.stringify(err));
        });
        this._rest.getStatus(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.respObject.details.unshift({id: 0, name: 'Select Status'});
            this.status = this.respObject.details;
            this.statusSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', JSON.stringify(err));
        });
        this.columnDefinitions = [
          // {id: 'id', name: 'Id', field: 'id', minWidth: 50, sortable: true, filterable: true},
          {id: 'TicketId', name: 'Ticket Id', field: 'TicketId', minWidth: 100, sortable: true, filterable: true},
          {
            id: 'TicketType', name: ' Ticket Type', field: 'TicketType', minWidth: 60, sortable: true, filterable: true
          },
          {
            id: 'TicketPriority', name: 'Ticket Priority', field: 'TicketPriority', minWidth: 60, sortable: true, filterable: true
          },
          {
            id: 'CategoryNm', name: 'Ticket Category', field: 'CategoryNm', sortable: true, minWidth: 100, filterable: true
          },
          {
            id: 'TotalResponseTime', name: 'SLA Response Time', field: 'TotalResponseTime',
            minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'TotalResolutionTime',
            name: 'SLA Resolution Time',
            field: 'TotalResolutionTime',
            minWidth: 100,
            sortable: true,
            filterable: true
          },
          {
            id: 'ticket_creation_date',
            name: 'Ticket Creation Time',
            field: 'ticket_creation_date',
            minWidth: 100,
            sortable: true,
            filterable: true
          },
          {
            id: 'response_datetime', name: 'Ticket Response Time', field: 'response_datetime',
            minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'resolution_datetime',
            name: 'Ticket Resolution Time',
            field: 'resolution_datetime',
            minWidth: 100,
            sortable: true,
            filterable: true
          },
          {
            id: 'is_sla_resolution_failure',
            name: 'Resolution SLA Violated Status ',
            field: 'is_sla_resolution_failure',
            minWidth: 50,
            sortable: true,
            filterable: true
          },
          {
            id: 'is_sla_response_failure',
            name: 'Response SLA Violated Status',
            field: 'is_sla_response_failure',
            minWidth: 50,
            sortable: true,
            filterable: true
          }
        ];

      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true
    };
    // getSupportGroupByClientId


    this.dataset = [];
  }

  handleSelectedRowsChanged(e, args) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles = args.rows.map(idx => {
        const item = this.gridObj.getDataItem(idx);
        return item || '';
      });
      if (this.selectedTitles.length > 0) {
        this.show = true;
        this.selected = this.selectedTitles.length;
      } else {
        this.show = false;
      }
      console.log(JSON.stringify(this.selectedTitles));
    }
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  generate() {
    const startDate = this.messageService.ticketConverter(this.dateStart, 1);
    const endDate = this.messageService.ticketConverter(this.dateEnd, 1);
    console.log(startDate, endDate, this.statusSelected);
    if (this.ticketSelected > 0) {
      this.hide_report_loader = false;
      this._rest.getSlaReport(startDate, endDate, this.clientId, this.ticketSelected,
        this.categorySelected, this.statusSelected).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.hide_report_loader = true;
          // this.clientId = this.respObject.details[0].clientId;
          // console.log(JSON.stringify(this.respObject.TotalSLADtls));
          this.dataset = this.respObject.details;
          // this.dataset = val;
          this.totalItems = this.dataset.length;
          // const a = this._rest.slaRoot + '/createCSV?fromDt=' + startDate + '&toDt=' + endDate + '&clientid=' + this.clientId +
          //   '&ticket_type=' + this.ticketSelected + '&category=' + this.categorySelected + '&ticket_status=' + this.statusSelected;
          // console.log('AAAAAAAAAAAAAAAAA=', a);
          window.open(this._rest.slaRoot + '/createCSV?fromDt=' + startDate + '&toDt=' + endDate + '&clientid=' + this.clientId +
            '&ticket_type=' + this.ticketSelected + '&category=' + this.categorySelected + '&ticket_status=' + this.statusSelected, '_blank');
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else {
      this.notifier.notify('error', this.messageService.BLANK_TYPE);
    }
  }

  onTicketChange(selectedIndex: any) {
    this.type = this.tickets[selectedIndex].name;
    this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        // console.log(this.respObject);
        this.respObject.details.unshift({id: 0, name: 'Select Category'});
        this.categories = this.respObject.details;
        this.categorySelected = 0;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }
}
